import React, { useState } from "react";
import { HostCard } from "./components/host-card";
import "./styles.scss";
import { hostData } from "./host-data";

export const Hosts = (): JSX.Element => {
  const [activeHost, setActiveHost] = useState<string>();

  const changeActiveHost = (id: string) => {
    setActiveHost(id);
  };
  return (
    <div className="hosts">
      <div className="hosts-wrapper">
        <h1 className="hosts-title">Meet the Hosts</h1>
        <div className="hosts-cards">
          {hostData.map((host) => (
            <HostCard
              host={host}
              key={host.name}
              setActiveHost={() => changeActiveHost(host.id)}
              canPlay={activeHost === host.id}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
